import React, { useState, useEffect } from "react";
import { useOutletContext, useLocation } from "react-router-dom";
import { SummaryForm } from "./proposals/components/SummaryForm";
import { PricingForm } from "./proposals/components/PricingForm";
import { QuestionsForm } from "./proposals/components/QuestionsForm";
import { ReverseAuctionForm } from "./proposals/components/ReverseAuctionForm";
import { SummaryReviewForm } from "./proposals/components/SummaryReviewForm";
import { InviteForm } from "./proposals/components/InviteForm";
import { ProposalSidebar } from "./proposals/components/ProposalSidebar";
import { proposalSections } from "./proposals/utils/proposalSections";

const NewProposal = () => {
  // Render the title in the outlet context
  if (useOutletContext() === "title-only") {
    return "Create New RFP/Instruction";
  }
  
  const location = useLocation();
  
  // Initialize from localStorage or default to "summary"
  const [activeSection, setActiveSection] = useState(() => {
    const saved = localStorage.getItem("proposal-active-section");
    return saved || "summary";
  });

  // Sync state with localStorage when it changes externally
  useEffect(() => {
    const saved = localStorage.getItem("proposal-active-section");
    if (saved && saved !== activeSection) {
      setActiveSection(saved);
    }
  }, [location.pathname]);

  // Handle section completion
  const handleSectionComplete = (nextSection: string) => {
    setActiveSection(nextSection);
    localStorage.setItem("proposal-active-section", nextSection);
  };

  // Update localStorage when active section changes via sidebar
  const handleSectionChange = (section: string) => {
    setActiveSection(section);
    localStorage.setItem("proposal-active-section", section);
  };

  return (
    <div className="animate-fade-in mt-2">
      <div className="bg-white shadow rounded-lg p-6 border border-gray-200">
        <p className="text-gray-600 mb-6">
          Start creating a new RFP/Instruction by filling out the sections below.
        </p>
        
        <div className="flex flex-col md:flex-row gap-6">
          {/* Sidebar Navigation */}
          <ProposalSidebar 
            sections={proposalSections}
            activeSection={activeSection}
            onSectionChange={handleSectionChange}
          />
          
          {/* Content Area */}
          <div className="flex-1 bg-white rounded-lg border border-gray-200 p-6">
            {activeSection === "summary" && <SummaryForm onSectionComplete={handleSectionComplete} />}
            {activeSection === "pricing" && <PricingForm onSectionComplete={handleSectionComplete} />}
            {activeSection === "questions" && <QuestionsForm onSectionComplete={handleSectionComplete} />}
            {activeSection === "reverse-auction" && <ReverseAuctionForm onSectionComplete={handleSectionComplete} />}
            {activeSection === "summary-review" && <SummaryReviewForm />}
            {activeSection === "invite" && <InviteForm />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewProposal;
